import { Component, Input } from "@angular/core"

@Component({
    selector: "tooltip",
    templateUrl: "tooltip.component.html",
    styleUrls: ["tooltip.component.scss"],
})
export class TooltipComponent {
    @Input() text: string
    @Input() description: string
    @Input() width: string
    @Input() marginLeft: number = 0
    @Input() marginTop: number = 0
    @Input() marginRight: number = 0
    @Input() marginBottom: number = 0
    @Input() textAlign: string = "left"
    @Input() class: string

    constructor() {}

    get hasExplicitWidth(): boolean {
        return this.width != null && this.width !== ""
    }

    getWrapperStyles(): Record<string, string> {
        if (!this.hasExplicitWidth) {
            return { width: "max-content" }
        }

        return { width: `${this.width}px` }
    }

    getContainerStyles(): Record<string, string | number> {
        const styles: Record<string, string | number> = {
            "text-align": this.textAlign,
            "margin-top": this.marginTop + "px",
            "margin-left": this.marginLeft + "px",
            "margin-bottom": this.marginBottom + "px",
            "margin-right": this.marginRight + "px",
        }

        if (this.hasExplicitWidth) {
            // Fill the sized overlay pane / wrapper exactly.
            styles["width"] = "100%"
        }

        return styles
    }
}
